/**
 * SourceCard Component
 * Displays individual research source
 */

import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Linking } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { Colors } from '@/constants/colors';
import { ResearchSource } from '@/types/research.types';

interface SourceCardProps {
  source: ResearchSource;
  index: number;
}

export const SourceCard: React.FC<SourceCardProps> = ({ source, index }) => {
  const handlePress = () => {
    Linking.openURL(source.url);
  };

  return (
    <TouchableOpacity style={styles.container} onPress={handlePress}>
      <View style={styles.header}>
        <Text style={styles.index}>[{index + 1}]</Text>
        <View style={styles.headerContent}>
          <Text style={styles.title} numberOfLines={2}>
            {source.title}
          </Text>
          <Text style={styles.sourceName}>{source.sourceName}</Text>
        </View>
        <Ionicons name="open-outline" size={20} color={Colors.text.tertiary} />
      </View>
      <Text style={styles.summary} numberOfLines={3}>
        {source.summary}
      </Text>
      <View style={styles.footer}>
        <View style={styles.relevanceBar}>
          <View
            style={[styles.relevanceFill, { width: `${Math.round(source.relevance * 100)}%` }]}
          />
        </View>
        <Text style={styles.relevanceText}>{Math.round(source.relevance * 100)}% relevant</Text>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.background.secondary,
    borderRadius: 12,
    padding: 14,
    marginBottom: 12,
    borderWidth: 1,
    borderColor: Colors.border.subtle,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 8,
  },
  index: {
    fontSize: 13,
    fontWeight: '700',
    color: Colors.accent.primary,
    marginRight: 8,
    marginTop: 2,
  },
  headerContent: {
    flex: 1,
  },
  title: {
    fontSize: 15,
    fontWeight: '600',
    color: Colors.text.primary,
    marginBottom: 4,
  },
  sourceName: {
    fontSize: 12,
    color: Colors.text.tertiary,
  },
  summary: {
    fontSize: 14,
    color: Colors.text.secondary,
    lineHeight: 20,
    marginBottom: 8,
  },
  footer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  relevanceBar: {
    flex: 1,
    height: 4,
    backgroundColor: Colors.background.primary,
    borderRadius: 2,
    marginRight: 8,
    overflow: 'hidden',
  },
  relevanceFill: {
    height: '100%',
    backgroundColor: Colors.accent.primary,
  },
  relevanceText: {
    fontSize: 11,
    color: Colors.text.tertiary,
    fontWeight: '600',
  },
});
